<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' class="m-b-25" :initialValues="search" :onFinish='pageSearchChange'
        layout='inline'>
        <a-form-item>
          <a-radio-group v-model:value="search.day" button-style="solid">
            <a-radio-button value="">全部</a-radio-button>
            <a-radio-button :value="2">最近7天</a-radio-button>
            <a-radio-button :value="3">最近30天</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="" name=''>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class="s_flex_bian_c m-b-40">
        <div class="width70 ">
          <div class="s_bor_cbed s_bf58 bor-rad-5 height-100 s_flex_bian_c m-b-10">
            <div class="width33">
              <p class="fz-20 s_c333 text-ac">0</p>
              <p class=" s_c666 text-ac">下单人数</p>
            </div>
            <div class="width33 s_bl1">
              <p class="fz-20 s_c333 text-ac">0</p>
              <p class=" s_c666 text-ac">下单笔数</p>
            </div>
            <div class="width33 s_bl1">
              <p class="fz-20 s_c333 text-ac">0</p>
              <p class=" s_c666 text-ac">下单金额</p>
            </div>
          </div>
          <div class="s_bor_cbed s_bf58 bor-rad-5 height-100 s_flex_bian_c">
            <div class="width33">
              <p class="fz-20 s_c333 text-ac">0</p>
              <p class=" s_c666 text-ac">付款人数</p>
            </div>
            <div class="width33 s_bl1">
              <p class="fz-20 s_c333 text-ac">0</p>
              <p class=" s_c666 text-ac">付款订单数</p>
            </div>
            <div class="width33 s_bl1">
              <p class="fz-20 s_c333 text-ac">0</p>
              <p class=" s_c666 text-ac">付款金额</p>
            </div>
          </div>
        </div>
        <div class="width28 s_bor_cbed s_bf58 bor-rad-5">
          <div class="height-100 s_flex_center">
            <div class="">
              <p class="fz-20 s_cd41 text-ac">0.00%</p>
              <p class=" s_c666 s_flex_center">
                参团转化率
                <a-tooltip>
                  <template #title>
                    参团转化率＝（参团单数／下单笔数）X 100%
                  </template>
                  <QuestionCircleOutlined class="s_c376 m-l-5" />
                </a-tooltip>
              </p>
            </div>
          </div>
          <div class="height-100 s_flex_center m-b-10">
            <div class="">
              <p class="fz-20 s_cd41 text-ac">0.00%</p>
              <p class=" s_c666 s_flex_center">
                成团率
                <a-tooltip>
                  <template #title>
                    成团率＝（成团单数／参团单数）X 100%
                  </template>
                  <QuestionCircleOutlined class="s_c376 m-l-5" />
                </a-tooltip>
              </p>
            </div>
          </div>
        </div>
      </div>
      <echartLine :echartsData='echartData' v-if='!listLoading'></echartLine>
    </a-card>
  </a-layout>
</template>
<script>
  import { QuestionCircleOutlined  } from '@ant-design/icons-vue';
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  let defSearch = {
    page: 1,
    limit: 10,
    day: ''
  };
  export default {
    components: { QuestionCircleOutlined },
    setup(props) {
      const search = ref({ ...defSearch });
      const state = reactive({
        echartData:{},
        listLoading:true,
        dayFans: {
          dataName: ['新增关注人数', '取消关注人数', '净增关注人数'],
          data1: [220, 232, 201, 234, 290, 230, 220],
          data2: [120, 200, 150, 80, 70, 110, 130],
          data3: [130, 180, 240, 100, 170, 140, 30]
        },
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')

      onMounted(() => {
      });
      return {
        ...toRefs(state),
        search
      };
    },
  };
</script>